var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91923 14.0568C2.52965 14.0568 2.19614 13.9262 1.91871 13.6651C1.64128 13.404 1.50256 13.0901 1.50256 12.7235V4.72347C1.50256 4.3568 1.64128 4.04291 1.91871 3.7818C2.19614 3.52069 2.52965 3.39014 2.91923 3.39014H14.2526C14.6421 3.39014 14.9757 3.52069 15.2531 3.7818C15.5305 4.04291 15.6692 4.3568 15.6692 4.72347V12.7235C15.6692 13.0901 15.5305 13.404 15.2531 13.6651C14.9757 13.9262 14.6421 14.0568 14.2526 14.0568H2.91923ZM8.5859 9.39014L2.91923 6.0568V12.7235H14.2526V6.0568L8.5859 9.39014ZM8.5859 8.0568L14.2526 4.72347H2.91923L8.5859 8.0568ZM2.91923 6.0568V4.72347V12.7235V6.0568Z",
    fill: "#1D1B20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.7f2e27eaae0026ae9f7bed74d90f7fb7.svg";
export { ForwardRef as ReactComponent };